<template>
  <div
    class="w-100"
    style="
      border: 1px solid #cccccc;
      border-radius: 8px;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
    "
  >
    <div class="p-3">
      <div class="input-group mb-3">
        <input
          dir="rtl"
          type="text"
          v-model="searchTerm"
          class="form-control small"
          placeholder=""
          aria-describedby="button-addon2"
        />
        <button
          class="btn btn-sm btn-outline-secondary"
          type="button"
          id="button-addon2"
          @click="doSearch"
        >
          جستجو
        </button>
      </div>
      <div
        class="d-flex flex-row bd-highlight mt-4"
        v-if="charts.length != 0"
        style="font-size: 14px"
      >
        <div class="bd-highlight">
          <div class="ms-auto bd-highlight">
            <nav aria-label="Chart note navigation">
              <ul class="pagination pagination-sm justify-content-center">
                <li class="page-item">
                  <select
                    class="page-link"
                    type="button"
                    v-model="sortField"
                    @change="getList()"
                  >
                    <option value="save_date">تاریخ</option>
                    <option value="title">عنوان</option>
                  </select>
                </li>
                <li class="page-item">
                  <select
                    class="page-link"
                    type="button"
                    v-model="sortOrder"
                    @change="getList()"
                  >
                    <option value="ASC" style="font-size: 24px">↑</option>
                    <option value="DESC" style="font-size: 24px">↓</option>
                  </select>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="me-auto" style="line-height: 30px; margin-left: 10px">مرتب‌سازی</div>

        <div class="ms-auto bd-highlight">
          <nav aria-label="Chart note navigation">
            <ul class="pagination pagination-sm justify-content-center">
              <li class="page-item">
                <select
                  class="page-link"
                  type="button"
                  v-model="perPage"
                  @click.prevent="changePage"
                >
                  <option value="5" selected>5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                </select>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ol class="list-group list-group-flush p-0" v-if="charts.length != 0" dir="rtl">
        <li
          class="list-group-item d-flex justify-content-between align-items-start"
          v-for="chart in charts"
        >
          <div class="ms-auto me-2">
            <div class="fw-bold">{{ chart.title }}</div>
            {{ convertToJalali(chart.save_date) }}
          </div>
          <span class="badge bg-primary rounded-pill">
            {{ chart.note_count }}
          </span>
        </li>
      </ol>
      <div class="d-flex flex-row bd-highlight mt-3" v-if="charts.length != 0">
        <div class="me-auto ms-auto bd-highlight">
          <nav aria-label="Chart note navigation">
            <ul class="pagination pagination-sm justify-content-center">
              <!-- Previous page button -->
              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(currentPage - 1)"
                  tabindex="-1"
                  aria-disabled="true"
                  >قبلی</a
                >
              </li>

              <!-- Page numbers -->
              <li
                v-for="pageNumber in displayPages"
                :key="pageNumber"
                class="page-item"
                :class="{ active: pageNumber === currentPage }"
              >
                <a class="page-link" href="#" @click.prevent="changePage(pageNumber)">{{
                  pageNumber
                }}</a>
              </li>

              <!-- Next page button -->
              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)"
                  >بعدی</a
                >
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div v-else>
        <div
          class="p-3"
          style="
            border: 1px solid #ced4da;
            background-color: #f9f9f9;
            direction: rtl;
            text-align: center;
            border-radius: 8px;
          "
        >
          <p class="mb-4">چارت یافت نشد.</p>
          <button class="btn btn-outline-danger" type="button" @click="resetSearch">
            بازگشت
          </button>
        </div>
      </div>
    </div>
    <Loading :is-loading="isLoading" />
  </div>
</template>

<script>

import ApiService from "../service/api";
import moment from "jalali-moment";
import Loading from "./Loading.vue";

export default {
  name: "ChartListPro",
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      charts: [],
      searchTerm: "",
      sortField: "save_date",
      sortOrder: "DESC",
      perPage: 5,
      currentPage: 1,
      totalCharts: 0,
      editor: [],
      editorData: "",
      editorConfig: {
        toolbar: ["bold", "italic", "|", "link"],
        language: {
          ui: "en",
          content: "ar",
        },
      },
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCharts / this.perPage);
    },
    displayPages() {
      const beforeCurrent = this.currentPage - 5;
      const afterCurrent = this.currentPage + 5;
      const pages = [];

      if (beforeCurrent > 1) {
        pages.push(1);
        if (beforeCurrent > 2) {
          pages.push(null);
        }
      }

      for (let i = beforeCurrent; i <= afterCurrent; i++) {
        if (i > 0 && i <= this.totalPages) {
          pages.push(i);
        }
      }

      if (afterCurrent < this.totalPages) {
        if (afterCurrent < this.totalPages - 1) {
          pages.push(null);
        }
        pages.push(this.totalPages);
      }

      return pages;
    },
  },
  methods: {
    resetSearch() {
      this.searchTerm = "";
      this.getList();
    },
    doSearch() {
      this.getList();
    },
    convertToJalali(date) {
      if (date != null)
        return moment.from(date, "en", "YYYY-MM-DD HH:mm").format("HH:mm jYYYY-jMM-jDD");
    },
    getList() {
      const params = {
        perPage: this.perPage,
        pageNumber: this.pageNumber,
        searchTerm: this.searchTerm,
        sortOrder: this.sortOrder,
        sortField: this.sortField,
        currentPage: this.currentPage,
      };

      this.isLoading = true;
      ApiService.listChart(params).then((response) => {
        // console.log(this.charts);
        this.charts = response["data"]["charts"];
        this.totalCharts = response["data"]["total_charts"];
        this.currentPage = response["data"]["currentPage"];
        this.isLoading = false;
      });
    },
    changePerPage(per_page) {
      this.getList();
    },
    changeSortOrder() {
      this.sortOrder = this.sortOrder === "ASC" ? "DESC" : "ASC";
      this.getList();
    },

    searchCharts() {
      this.currentPage = 1;
      this.getList();
    },

    changePage(page) {
      // console.log(page)
      this.currentPage = Number(page);
      this.getList();
    },
  },
};
</script>


<style scoped>
.note-title {
  font-size: 14px;
}
</style>
